import { render, staticRenderFns } from "./mySalesBuyers.vue?vue&type=template&id=0a3b4598&scoped=true&lang=html&"
import script from "./mySalesBuyers.vue?vue&type=script&lang=js&"
export * from "./mySalesBuyers.vue?vue&type=script&lang=js&"
import style0 from "./mySalesBuyers.vue?vue&type=style&index=0&id=0a3b4598&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3b4598",
  null
  
)

export default component.exports